import { Stack, IconButton, Link } from "@mui/material"


const FooterItem = ({ item }) => {

    return(
        <Stack direction='row'>

            <IconButton href={item.link}>
                <img src={item.icon} alt="" height="30px" width="30px"/>
            </IconButton>

            <Link sx={{
                cursor: "pointer",
                textDecoration: "none",
                fontSize: { xs: "10px", sm: "18px" }}} 
                alignSelf="center" 
                color="#ffff" 
                href={item.link}>
                    
                {item.contact}
            </Link>
        </Stack>
    );
}

export default FooterItem;